import { useOutletContext } from "react-router-dom";
import { Link } from "react-router-dom";
import { Crown, Calendar, Clock, TrendingUp } from "lucide-react";

export default function AdminOverview() {
  const { stats } = useOutletContext();
  if (!stats) return null;

  const cards = [
    { label: "Pending Reservations", value: stats.pending, icon: Clock, link: "/admin/reservations", accent: true },
    { label: "Approved", value: stats.approved, icon: Crown, link: "/admin/reservations" },
    { label: "Confirmed", value: stats.confirmed, icon: TrendingUp, link: "/admin/reservations" },
    { label: "Tonight's Bookings", value: stats.today_reservations, icon: Calendar, link: "/admin/reservations" },
    { label: "Total Reservations", value: stats.total_reservations, icon: Crown, link: "/admin/reservations" },
    { label: "Active Events", value: stats.events, icon: Calendar, link: "/admin/events" },
  ];

  return (
    <div data-testid="admin-overview">
      <div className="mb-10">
        <span className="eyebrow">— Dashboard</span>
        <h1 className="font-display text-4xl md:text-5xl mt-3">Welcome back, <span className="italic text-gold">Onyx</span>.</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.label} to={c.link} className="bg-black p-8 hover:bg-[var(--onyx-charcoal)] transition-colors group">
              <div className="flex items-start justify-between mb-6"><Icon size={18} className={c.accent ? "text-gold" : "text-white/40"} /><span className="text-[10px] tracking-luxe uppercase text-white/30">View →</span></div>
              <p className={`font-display text-6xl ${c.accent ? "text-gold" : "text-white"}`}>{c.value}</p>
              <p className="text-[11px] tracking-luxe uppercase text-white/50 mt-3">{c.label}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
